import React from "react";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
  makeStyles
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: "20px",
    color: TEXT.primary,
  },
  dialogText: {
    fontFamily: `'Inter',sans-serif`,
    fontSize: "15px",
    color: TEXT.secondary,
    lineHeight: "1.6",
  },
  agreeBtn: {
    background: "#2F80ED",
    color: "white",
    textTransform: "none",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    padding: "0.5rem 1.5rem",
    "&:hover": {
      background: "#1B60C4",
    },
  },
  disagreeBtn: {
    color: TEXT.error,
    borderColor: "#FF5A5F",
    textTransform: "none",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    padding: "0.5rem 1.5rem",
  }
}));

export default function SimpleDialog({ open, title, subTitle, handleAgreeBtn, closeModal }) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title" disableTypography className={classes.dialogTitle}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description" className={classes.dialogText}>
          {subTitle}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: "1rem 1.5rem" }}>
        <Button
          variant="contained"
          className={classes.agreeBtn}
          onClick={handleAgreeBtn}
        >
          Yes
        </Button>
        <Button
          variant="outlined"
          className={classes.disagreeBtn}
          onClick={closeModal}
          autoFocus
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}
